import React from "react";
import styles from "./QueryArticles.module.css";
import {
  Article,
  Error,
  Loader,
  PaginationUI,
  SortingSelect,
} from "../../components";

const QueryArticlesUI = ({ searchTerm, error, loading, articles }) => {
  return (
    <div className={styles.query_articles_page}>
      <header className={styles.query_articles_header}>
        <div className={styles.query_title_container}>
          {error && <Error errorMessage={error} />}
          {articles.length === 0 && !loading && (
            <p className={styles.articles_not_found}>
              No articles which contains <span>{searchTerm}</span> search term
            </p>
          )}
          {articles.length > 0 && <h1>{searchTerm}</h1>}
          {articles.length > 0 && <SortingSelect />}
        </div>
      </header>
      {loading && <Loader />}
      {articles.length > 0 && <PaginationUI />}

      <div className={styles.articles_layout}>
        {articles.map((article) => (
          <Article
            key={article.slug}
            article={article}
            articleType="query-article"
          />
        ))}
      </div>

      {articles.length > 0 && <PaginationUI />}
    </div>
  );
};

export default QueryArticlesUI;
